// src/components/common/Form/Footer.jsx
import React from "react";
import "./style.css";

const CustomFooter = ({ line1, line2 }) => (
  <footer className="form-footer">
    <p>{line1}</p>
    <p>{line2}</p>
  </footer>
);

export default CustomFooter;
